import React, { useContext, useEffect } from 'react';
import im1 from './Assets/grid1.png'
import im2 from './Assets/grid2.png'
import im3 from './Assets/grid4.png'
import im4 from './Assets/grid3.png'

import Spline from '@splinetool/react-spline';
import { Icon } from '@iconify/react/dist/iconify.js';
import { addcontext } from '../ContextShare/ContextShare';
import AOS from 'aos'; // Import AOS library

function Page4() {
  const { NavSelected, setNavSelected } = useContext(addcontext)

  const handleemailCOpy = () => {
    const email = "adilkkinbox@gmail.com"; // Replace this with the email you want to copy
    navigator.clipboard.writeText(email)
      .then(() => {
        alert("Email copied to clipboard!");
        // You can also add some UI feedback like a notification or tooltip
      })
      .catch((err) => {
        console.error("Failed to copy email: ", err);
      });
  };

  // Initialize AOS when the component mounts
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Whether animation should happen only once while scrolling down
    });
  }, []);
  return (
    <div className="flex flex-col justify-center items-center w-full min-h-screen bg-black" style={{ fontFamily: 'ropa sans' }}>
      <div className="flex flex-wrap gap-6 w-full max-w-screen-2xl md:p-8 p-4 justify-center">
        {/* First column */}
        <div className="flex flex-col gap-6 w-[900px]">
          <div className="flex gap-6 md:flex-row flex-col">
            {/* Larger boxes with responsive width */}
            <div data-aos="fade-up" className="bg-[#080808] h-[500px] md:w-6/12 w-full rounded-lg flex flex-col justify-start pt-5 items-center border border-gray-700">
              <img src={im1} alt="grid1" className='w-11/12 h-[340px]' />
              <div className='flex justify-start w-full ps-6'><h2 className='text-white font-bold text-xl'>Hi, I'm Adil</h2></div>
              <div className='flex justify-start w-full ps-6'><p className='text-white text-sm pt-5'>With 2 years of experience/ I have honed my skills in front end designing & developement and backend development, with a focus on animated 3D websites.</p></div>
            </div>

            <div data-aos="fade-up" className="bg-[#080808] h-[500px] md:w-6/12 w-full rounded-lg flex flex-col pt-5 justify-start items-center border border-gray-700">
              <img src={im2} alt="grid1" className='w-11/12 h-[340px]' />
              <div className='flex justify-start w-full ps-6'><h2 className='text-white font-bold text-xl '>Tech Stack</h2></div>
              <div className='flex justify-start w-full ps-6'><p className='text-white text-sm pt-5'>I specialised in Javascript with a focus on React and Next.js ecosystems.</p></div>
            </div>

          </div>
          <div data-aos="fade-up" className="bg-black h-[500px] w-full rounded-lg border border-gray-700 flex flex-col justify-start items-center">
            <div className='w-full h-5/6'><Spline scene="https://prod.spline.design/0j33N2-yL3xu19Q6/scene.splinecode" /></div>
            <div className='flex justify-start w-full ps-6'><h2 className='text-white font-bold text-xl pt-2'>I work remotely across most timezones</h2></div>
            <div className='flex justify-start w-full ps-6'><p className='text-white text-sm pt-5'>I'm based in India, with remote work available.</p></div>

          </div> {/* Large box below the two smaller ones */}
        </div>

        {/* Second column */}
        <div className="flex flex-col gap-6 w-[450px] rounded">
          <div data-aos="fade-up" className="bg-[#080808] h-[600px] w-full rounded-lg border border-gray-700 flex flex-col pt-5 justify-start items-center">
            <img src={im4} alt="grid1" className='w-full object-cover h-[340px]' />
            <div className='flex justify-start w-full ps-6'><h2 className='text-white font-bold text-xl'>My Passion for Coding</h2></div>
            <div className='flex justify-start w-full ps-6'><p className='text-white text-sm pt-5'>I love solving problems and building worlds through code.
              Coding isn’t just my profession, it’s my passion, my art.
              I find beauty in both design and development,
              Where creativity meets logic, and ideas come to life. </p></div>
            <div className='pt-10'><button className='px-4 py-1 rounded-lg border border-gray-700 text-gray-400' onClick={() => setNavSelected('Projects')}>View my works</button></div>
          </div> {/* Tall element */}
          <div data-aos="fade-up" className="bg-[#080808] h-[400px] w-full rounded-lg border border-gray-700 justify-start items-center">
            <img src={im3} alt="grid1" className='w-full h-[290px]' />
            <div className='flex justify-center w-full '><h2 className='text-white '>contact me</h2></div>
            <div className='flex w-full pt-3 justify-center text-white font-bold text-lg items-center gap-1' onClick={handleemailCOpy}><Icon icon="fluent:copy-24-regular" /><span>adilkkinbox@gmail.com</span></div>
          </div> {/* Smaller element */}
        </div>
      </div>
    </div>
  );
}

export default Page4;
